module.exports = "/images/up-down.svg?cf57e58bc0ae544f15556fb5f24db5cc";